import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoriesSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门视频<strong className="text-primary-500">分类</strong>
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            丰富多彩的内容分类，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 flex flex-col items-center text-center gap-3 cursor-pointer"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${category.color} transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${category.icon} text-xl md:text-2xl`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-950 mb-1">
                  {category.name}
                </h3>
                <span className="text-xs text-foreground-400">
                  {(category.count / 10000).toFixed(1)}万+ 视频
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/gaoxiao"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}